/*! HorizontalSmoothScrollLayout | MIT License | https://github.com/codrops/HorizontalSmoothScrollLayout */

import imagesLoaded from "imagesloaded";

// Map number x from range [a, b] to [c, d]
const map = (x: number, a: number, b: number, c: number, d: number) =>
  ((x - a) * (d - c)) / (b - a) + c;

// Linear interpolation
const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;

const clamp = (num: number, min: number, max: number) =>
  num <= min ? min : num >= max ? max : num;

const randomNumber = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);

// Gets the mouse position
const getMousePos = (e: MouseEvent) => {
  return {
    x: e.clientX,
    y: e.clientY,
  };
};

// Preload images
const preloadImages = (selector: string = "img") => {
  return new Promise((resolve) => {
    imagesLoaded(
      document.querySelectorAll(selector),
      { background: true },
      resolve
    );
  });
};

// Preload fonts
const preloadFonts = (id: string) => {
  // return new Promise((resolve) => {
  //   // @ts-ignore
  //   WebFont.load({
  //     typekit: {
  //       id: id,
  //     },
  //     active: resolve,
  //   });
  // });

  return Promise.all([
    document.fonts.load("1em Martian Mono"),
    document.fonts.load("1em Gambarino"),
  ]).then(() => {
    console.log("Fonts loaded");
  });
};

// wrap each element of an array
// elems - the array of elements to wrap
// wrapType - type of wrapper ('div', 'span' etc)
// wrapClass - wrapper class(s)
const wrapLines = (
  elems: HTMLElement[],
  wrapType: "span" | "div",
  wrapClass: string
) => {
  elems.forEach((char) => {
    // add a wrap for every char (overflow hidden)
    const wrapEl = document.createElement(wrapType);
    wrapEl.classList.add(wrapClass);
    char.parentNode?.appendChild(wrapEl);
    wrapEl.appendChild(char);
  });
};

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export {
  map,
  lerp,
  clamp,
  randomNumber,
  getMousePos,
  preloadImages,
  preloadFonts,
  wrapLines,
  isSafari,
};
